<template>
    <div>
        <el-slider
        v-model="currentValue"
        :min="min"
        :max="max"
        :marks="marks"
        :show-input="showInput"
        :disabled="mode !== 'edit'">
        </el-slider>
    </div>
</template>
<script>
    export default {
        props: {
            mode: {
                type: String
            },
            value: {
                type: Number,
                required: true,
            },
            min: {
                type: Number,
                required: false,
                default: 0
            },
            max: {
                type: Number,
                required: false,
                default: 100
            },
            showInput: {
                type: Boolean,
                required: false,
                default: false
            },
            marks: {
                type: Object,
                required: false,
                default: () => {}
            }
        },
        data() {
            return {
                currentValue: 0
            }
        },
        mounted() {
            this.currentValue = this.value;
        },
        watch: {
            value(newValue){
                this.currentValue = newValue;
            },
            currentValue(newValue){
                this.$emit('input', newValue)
                this.$emit('change', newValue)
            }
        }
    }
</script>

<style lang="scss"> 
    .el-slider .el-input-number  {
        .el-icon-minus, 
        .el-icon-plus {
            line-height: 22px;
        }
    } 
</style>